// Create this new file: src/pages/VendorProfile.js

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ProfilePage from '../components/ProfilePage';
import { Button, Box } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

const VendorProfile = () => {
  const { id } = useParams(); // Get vendor ID from URL
  const navigate = useNavigate();

  return (
    <Box>
      {/* Back button to return to vendors list */}
      <Box mb={2}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate('/erp/accounts/vendors')}
          variant="outlined"
          size="small"
        >
          Back to Vendors
        </Button>
      </Box>
      
      {/* Profile component with the vendor ID */}
      <ProfilePage 
        entityType="vendor" 
        entityId={parseInt(id)} // Pass the ID from URL
      />
    </Box>
  );
};

export default VendorProfile;